<template lang="pug">
  b-container
    //- b-modal#AddTopicModal(v-model="showTopicModal", title="Add topic", hide-footer)
      b-container
        b-form(ref='addQuestionForm', @submit.prevent="addTopic()")
          b-form-group
            label TOPIC
            b-form-input(type="text", required, v-model="inputFormTopic.title", placeholder='Topic')
          b-button.ml-auto(type='submit', ref='btnSubmit') Submit
    b-modal#AddQuestionModal(v-model="showQuestionModal", title="Add question", hide-footer)
      b-container
        b-form(ref='addQuestionForm', @submit.prevent="addFaq()")
          b-container
            .row
              .col-6
                b-form-group
                  label AUDIENCE
                  b-form-select(:options="app_user_roles", required, v-model="inputFormQuestion.app_user_role", placeholder="Audience")
              .col-6
                b-form-group
                  label TOPIC
                  b-form-select(:options="faq_topics", required, text-field="title", value-field="id", v-model="inputFormQuestion.topic_id", placeholder="Topic")
            b-form-group
              label QUESTION
              b-form-input(type="text", required, v-model="inputFormQuestion.title", maxlength="140", placeholder='Question')
            b-form-group
              label ANSWER
              b-form-textarea(rows='3', required, max-rows='6' v-model='inputFormQuestion.content', maxlength="1024", placeholder='Answer')
            b-form-group
              label FULL ARTICLE LINK (optional)
              b-form-input(type="text", v-model="inputFormQuestion.full_article_link")
            b-button.ml-auto(type='submit', ref='btnSubmit') Submit
    content-loader(:height="7", v-if="alert.loading")
    div(v-else="")
      b-card.p-2
        .container
          .text-md-right
            //- b-button.btn-light.mr-2.m-2(@click="showTopicModal = !showTopicModal")
              font-awesome-icon.mr-2(icon="plus")
              span TOPIC
            b-button.btn-light.m-2(@click="showQuestionModal = !showQuestionModal")
              font-awesome-icon.mr-2(icon="plus")
              span QUESTION
          p(v-if='faqs.length < 1') No articles found
          b-tabs
            b-tab.pt-2(v-for="(app_user_role, index) in app_user_roles", :key="index", :title="app_user_role.toUpperCase()")
              div.faq-group.p-3(role='tablist', v-for='topic in faq_topics', :key="topic.id")
                .row
                  .col-6
                    a.faq-tile(href='#', v-b-toggle="'accordion-' + kebabMe(topic.title)", variant='primary')
                      .mr-3.fa.fa-caret-down
                      span.text-uppercase {{ topic.title }}
                      span.text-muted {{ `(${faqs.filter(item => (item.topic_id === topic.id && item.app_user_role === app_user_role)).length})` }}
                  .col-6.text-right(v-if="faqs.filter(item => item.topic_id === topic.id).length < 1")
                    a(@click="deleteTopic(topic.id)")
                      font-awesome-icon(icon="trash-alt")
                b-collapse(v-bind:id="'accordion-'+kebabMe(topic.title)", accordion='my-accordion', role='tabpanel')
                  .container
                    .row(v-for="faq in faqs.filter(item => (item.topic_id === topic.id && item.app_user_role === app_user_role))", :key="faq.id")
                      .col-12
                        hr
                      .col-11
                        h4.mt-0 {{ faq.title }}
                        p.faq-text {{ faq.content }}
                        a.text-primary(v-if="faq.link", :href="faq.full_article_link") Full Article
                      .col-1
                        b-button-group
                            b-dropdown.m-0(no-caret="", variant="light")
                              template(v-slot:button-content="")
                                font-awesome-icon(icon="ellipsis-v")
                              b-dropdown-item(@click="deleteQuestion(faq.id)") Delete
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'ContentFaq',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      faqs: [],
      faq_topics: [],
      app_user_roles: ['customer', 'artist'],
      showTopicModal: false,
      showQuestionModal: false,
      inputFormQuestion: {
        topic_id: '',
        app_user_role: '',
        title: '',
        content: '',
        full_article_link: '',
      },
      inputFormTopic: {
        title: '',
      },
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'title', label: 'Question', sortable: true },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
  },
  methods: {
    async deleteFaq(id) {
      try {
        this.busy();
        await apiService.deleteFaq(id);
        const indexOfItem = this.faqs.findIndex(item => item.id === id);
        this.$delete(this.faqs, indexOfItem);
        this.success('Item removed');
      } catch (error) {
        this.error('Could not delete item');
      }
    },
    async addFaq() {
      try {
        this.busy();
        const question = await apiService.addFaq(this.inputFormQuestion);
        this.faqs.push(question);
        this.showQuestionModal = false;
        this.success('Item added');
      } catch (error) {
        this.error('Could not add item');
      }
    },
  },
  async created() {
    try {
      this.loading();
      this.faqs = await apiService.getFaqs();
      this.faq_topics = await apiService.getFaqTopics();
      this.clear();
    } catch (error) {
      this.error('Could not load items');
    }
  },
};
</script>

<style lang="scss" scoped>
  .table-responsive {
    margin-bottom: 0;
  }

  .card-body {
    padding: 0;
  }

  .logo {
    width: 200px;
    max-height: 200px;
  }

  .faq-text {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ContentFaq.vue